import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/ykrestapi';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(
  (config) => {
    const authData = localStorage.getItem('yk_auth');
    if (authData) {
      const parsed = JSON.parse(authData);
      const token = parsed?.user?.token || parsed?.user?.userData?.token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('yk_auth');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
